module.exports = __webpack_public_path__ + "img/tag-money-disabled.80ed2096.svg";